import * as React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import SendIcon from "@mui/icons-material/Send";

function Invitati(props) {
  const [rows, setRows] = React.useState([]);
  const isLocalDev =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development";
  const baseUrl = isLocalDev ? "http://localhost:8000/" : "/";

  let urlImg = baseUrl + "invitati.php";

  React.useEffect(() => {
    var data = new FormData();
    data.append("key", localStorage.getItem("giorgia"));
    fetch(urlImg, {
      method: "POST",
      body: data,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setRows(createData(data));
      })
      .catch((e) => {
        console.log(e);
      });
  }, [urlImg]);

  const cb = () => {
    var data = new FormData();
    data.append("key", localStorage.getItem("giorgia"));
    fetch(`${urlImg}?download`, {
      method: "POST",
      body: data,
    })
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        var file = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = file;
        a.download = "invitati.csv";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Button
        variant="contained"
        color="secondary"
        sx={{ width: "-webkit-fill-available", margin: "20px" }}
        onClick={cb}
        endIcon={<SendIcon />}
      >
        Download
      </Button>
      <Stack spacing={0}>
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table" size="small">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Partecipazione</TableCell>
                <TableCell align="right">Invitati</TableCell>
                <TableCell align="right">Mail</TableCell>
                <TableCell align="right">Cell</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <Row key={row.id} row={row} />
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell />
                <TableCell></TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "#000", fontSize: "1em" }}
                >
                  <b>
                    Totale:
                    {rows.map((e) => e.invitati).reduce((e, a) => e + +a, 0)}
                  </b>
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Stack>
    </Box>
  );
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          {row.partecipazione && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell component="th" scope="row">
          {row.partecipazione ? (
            <CheckCircleOutlineIcon color="success" />
          ) : (
            <CancelIcon color="error" />
          )}
        </TableCell>
        <TableCell align="right">{row.invitati}</TableCell>
        <TableCell align="right">{row.mail}</TableCell>
        <TableCell align="right">{row.cell}</TableCell>
      </TableRow>
      {row.partecipazione && (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Invitati
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nome</TableCell>
                      <TableCell>Dieta</TableCell>
                      <TableCell align="right">Note</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.details.map((detailRow) => {
                      return (
                        <TableRow key={detailRow.id}>
                          <TableCell component="th" scope="row">
                            {detailRow.nome}
                          </TableCell>
                          <TableCell>{detailRow.dieta}</TableCell>
                          <TableCell align="right">{detailRow.note}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
}

function createData(rows) {
  let out = [];
  let id = 0;
  for (var i in rows) {
    const data = rows[i];
    if (!data) continue;
    let det = [];
    var nomi = JSON.parse(data.nomi);
    var diete = JSON.parse(data.diete);
    var note = JSON.parse(data.note);
    if (typeof nomi !== "object") {
      nomi = [];
    }
    if (typeof diete !== "object") {
      diete = [];
    }
    if (typeof note !== "object") {
      note = [];
    }
    for (let j = 0; j < data.count; j++) {
      det.push({
        id: j,
        nome: nomi[j],
        dieta: diete[j],
        note: note[j],
      });
    }
    out.push({
      id: id++,
      partecipazione: Number(data.partecipation) === 1 ? true : false,
      invitati: data.count,
      mail: data.mail,
      cell: data.cell,
      details: det,
    });
  }
  return out;
}

export default Invitati;
